import type { CSSProperties, ReactNode } from "react";
import { forwardRef } from "react";

import "../../styles/inputs/buttonInput.css";
import { ExpandingTooltipReturn } from "../hooks/useAdvancedTooltip";

export { ButtonInput, Props as ButtonInputProps };

type Props = {
  name?: string;
  placeholder?: string;
  disabled?: boolean;
  /* buttonInput class always */
  className?: string;
  style?: CSSProperties;
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  /* Buttons to be rendered after input */
  children?: ReactNode;
  tProps?: ExpandingTooltipReturn["triggerProps"];
};

/**
 * Component that styles all buttons
 * @param props
 * @returns
 */
const ButtonInput = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const className = props.className
    ? `buttonInput ${props.className}`
    : "buttonInput";
  return (
    <div className={className}>
      <input
        ref={ref}
        placeholder={props.placeholder}
        name={props.name}
        type={"text"}
        value={props.value}
        onBlur={props.onBlur}
        disabled={props.disabled}
        onFocus={props.onFocus}
        onChange={props.onChange}
        onKeyDown={props.onKeyDown}
        style={props.style}
        {...props.tProps}
      />
      {props.children}
    </div>
  );
});
